const visit = require('unist-util-visit')
const katex_ = require('katex');
require('katex/dist/contrib/mhchem.js');
const katex = katex_.renderToString
const unified = require('unified')
const parse = require('rehype-parse')
const toText = require('hast-util-to-text')

module.exports = rehypeKatex

const assign = Object.assign

const parseHtml = unified().use(parse, { fragment: true, position: false, })

const source = 'rehype-katex'

function rehypeKatex(options) {
  const settings = options || {}
  const throwOnError = settings.throwOnError || false

  return transformMath

  function transformMath(tree, file) {
    visit(tree, 'element', onelement)
    function onelement(element) {
      const classes = element.properties.className || []
      const inline = classes.includes('math-inline')
      const displayMode = classes.includes('math-display')

      if (!inline && !displayMode) {
        return
      }

      let value = toText(element)
      let result
      if (value.match(/$$/) && inline) {
        //HACKISH FIX for DELIMETER MATCH $$ in inline mode $_some_math_text_inline$$_other_math_text_online$
        value = value.split("$$").join(' ');
      }
      try {
        result = katex(
          value,
          assign({}, settings, { displayMode: displayMode, throwOnError: false, strict: 'ignore' })
        )
      } catch (error) {
        // Swallow silently — avoids the vfile-message@2 minification bug where
        // `parts` is renamed to `l` in declarations but not at the two usages
        // `this.source = parts[0]` / `this.ruleId = parts[1]`, which throws
        // ReferenceError: parts is not defined in production bundles.
        result = ''
      }

      element.children = parseHtml.parse(result).children
    }
  }
}
